/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import App from './App';
import React from 'react';

/**
 * EXTENSIONS AND MODES
 * =================
 * pluginImports.js is dynamically generated from extension and mode
 * configuration at build time.
 *
 * pluginImports.js imports all of the modes and extensions and adds them
 * to the window for processing.
 */
import { modes as defaultModes, extensions as defaultExtensions } from './pluginImports';
import loadDynamicConfig from './loadDynamicConfig';
import ElectronSyncService from './sync/ElectronSyncService';
export { history } from './utils/history';
export { preserveQueryParameters, preserveQueryStrings } from './utils/preserveQueryParameters';

loadDynamicConfig(window /** @type {any} */['config']).then(config_json => {
  // Reset Dynamic config if defined
  if (config_json !== null) {
    try {
      window /** @type {any} */['config'] = config_json;
    } catch {}
  }

  /**
   * Combine our appConfiguration with installed extensions and modes.
   * In the future appConfiguration may contain modes added at runtime.
   *  */
  const appProps = {
    config: window ? window /** @type {any} */['config'] : {},
    defaultExtensions,
    defaultModes,
  };

  const container = document.getElementById('root');

  const root = createRoot(container);
  const AnyApp = /** @type {any} */ (App);
  root.render(React.createElement(AnyApp, appProps));
  try {
    const bridge = window && window['directViewerBridge'];
    if (bridge) {
      const maybeInit = () => {
        const servicesManager = window && window['servicesManager'];
        if (!servicesManager) return;
        const sync = new ElectronSyncService(servicesManager);
        try {
          window['__electronSync__'] = sync;
        } catch {}
        window.addEventListener('directviewer:propagating', e => {
          try {
            const anyEvt = /** @type {any} */ (e);
            const enabled = anyEvt && anyEvt.detail && anyEvt.detail.enabled;
            if (enabled) sync.enable();
            else sync.disable();
          } catch {}
        });
      };
      setTimeout(maybeInit, 1500);
    }
  } catch {}
});
